<template>
    <div id="settingErr">
      <div id="sucContent">
        <div class="col-md-24 text-center">
            <p class="titleErr">
               <i class="err icon el-icon-circle-close-outline"></i>
                授权失败</p>
            <p class="titleCont">对不起，授权失败。请检查您的配置信息，稍后重新授权</p>
        </div>
        <div class="col-md-24 text-center">
          <el-button   type="primary"  class="submitSuc" @click="backIntention">返回服务配置</el-button>
          <el-button   type="primary"  class="submitSuc" @click="searchList">查看攻略</el-button>
        </div>
      </div>

    </div>
</template>

<script>
    export default {
        props: [],
      methods:{
        backIntention(){
          this.$router.go(-2)
        },
        searchList(){
         // this.$store.dispatch("changeA",flag);
          this.$router.push({path: '/tutor/znjjjnjs'})

        }
      }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
  #settingErr {
    width: 100%;
    height: 100%;
    display: table;
     #sucContent{
       height:300px;
       width: 100%;
       text-align: center;
       display: table-cell;
         padding-top:200px;
         /*vertical-align:middle;*/
       .titleErr{
        .err{
            font-weight: 600;
            font-size: 26px;
        }
         color:crimson;
         font-size: 24px;
         margin-bottom: 45px;
       }
       .titleCont{
         color:#646464;
         font-size: 14px;
         margin-bottom: 55px;
       }
       .submitSuc{
         border-radius:15px;
         width: 125px;
         margin-right: 15px;
       }

     }

  }
</style>



// WEBPACK FOOTER //
// src/components/setting/SettingErr.vue